import { devicePropertyOptions } from "fleet/constant/device-details";
import { flagOptions } from "fleet/constant/flags";
import { BulkDeviceEditPage } from "fleet/view/device/bulk-edit";
import { connect } from "react-redux";
import {
  applicationsSelector,
  getAppParamOptions,
  installedAppsSelector,
} from "redux-store/applications/selectors";
import { devicesSelector, getTargets } from "redux-store/devices/selectors";
import { makeGetAllAsArray } from "redux-store/selectors";
import { deviceService } from "service/device";
import { socket } from "websocket";

const getAppsAsArray = makeGetAllAsArray();
const getDevicesAsArray = makeGetAllAsArray();

function mapStateToProps(state) {
  const appsById = applicationsSelector(state);
  const apps = getAppsAsArray({ byId: appsById });
  const installedApps = installedAppsSelector(apps);
  const appParamOptions = getAppParamOptions(installedApps);
  const devicesById = devicesSelector(state);
  const devices = getDevicesAsArray({ byId: devicesById });
  const targetOptions = getTargets(devices, true);

  return {
    appParamOptions,
    devicePropertyOptions,
    flagOptions,
    targetOptions,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    bulkEditDevices: (serviceArgs) => {
      return deviceService
        .bulkEdit(serviceArgs.file, socket.id)
        .then((resp) => resp.data.data);
    },
  };
}

const ConnectedBulkDeviceEditPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(BulkDeviceEditPage);

export { ConnectedBulkDeviceEditPage };
